import React from 'react';
import type { Product, ProductVariant } from '../../types';
import { groupVariants, productSelectLabel, sortProductsForSelect } from '../../utils/packagingGroup';

interface ProductVariantSelectsProps {
  products: Product[];
  variants: ProductVariant[];
  productId: string;
  variantId: string;
  onProductChange: (productId: string) => void;
  onVariantChange: (variantId: string) => void;
  formatVariantLabel: (variant: ProductVariant) => string;
  controlClass: string;
}

export const ProductVariantSelects: React.FC<ProductVariantSelectsProps> = ({
  products,
  variants,
  productId,
  variantId,
  onProductChange,
  onVariantChange,
  formatVariantLabel,
  controlClass,
}) => {
  const sortedProducts = sortProductsForSelect(
    products.filter((p) => p.is_active !== false && !p.lead_priority)
  );
  const variantGroups = groupVariants(variants);
  const showVariantGroups = variantGroups.length > 1;

  return (
    <>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product <span className="text-red-500">*</span>
        </label>
        <select
          value={productId}
          onChange={(e) => onProductChange(e.target.value)}
          className={controlClass}
        >
          <option value="">-- Select --</option>
          {sortedProducts.map((product) => (
            <option key={product.id} value={product.id}>
              {productSelectLabel(product)}
            </option>
          ))}
        </select>
      </div>

      {variants.length > 0 ? (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Gebinde
          </label>
          <select
            value={variantId}
            onChange={(e) => onVariantChange(e.target.value)}
            className={controlClass}
          >
            <option value="">-- Select --</option>
            {showVariantGroups
              ? variantGroups.map((group) => (
                  <optgroup key={group.kind} label={group.label}>
                    {group.items.map((variant) => (
                      <option key={variant.id} value={variant.id}>
                        {formatVariantLabel(variant)}
                      </option>
                    ))}
                  </optgroup>
                ))
              : variants.map((variant) => (
                  <option key={variant.id} value={variant.id}>
                    {formatVariantLabel(variant)}
                  </option>
                ))}
          </select>
        </div>
      ) : null}
    </>
  );
};
